var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewClaimsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3346 5.33333H6.0013V6.66667H19.3346V5.33333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3346 10.6667H6.0013V12H19.3346V10.6667Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3346 16H6.0013V17.3333H15.3346V16Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0013 26H24.668V1.33333C24.668 0.598 24.07 0 23.3346 0H2.0013C1.26597 0 0.667969 0.598 0.667969 1.33333V28C0.667969 30.206 2.46197 32 4.66797 32H23.3346C25.5406 32 27.3346 30.206 27.3346 28V27.3333C27.3346 26.598 26.7366 26 26.0013 26ZM2.0013 28V1.33333H23.3346V26H8.66797C7.93264 26 7.33464 26.598 7.33464 27.3333V28C7.33464 29.4707 6.13864 30.6667 4.66797 30.6667C3.1973 30.6667 2.0013 29.4707 2.0013 28ZM23.3346 30.6667H7.6413C8.2773 29.958 8.66797 29.0253 8.66797 28V27.3333H26.0013V28C26.0013 29.4707 24.8053 30.6667 23.3346 30.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewClaimsMenu);
export default __webpack_public_path__ + "static/media/view_claims_menu.58f47813cad6edda323f30a9d251cd1c.svg";
export { ForwardRef as ReactComponent };